import { REPEAT_MODE } from '../constants/repeatTypes'
import { RESOLVE_TO } from '../constants'
import { getRandomScheduleId } from 'routes/Studies/routes/Study/routes/Instruments/utils/getRandomScheduleId'
import { createLocalId } from './ids'
import { createEmptyAnchor } from './createEmptyAnchor'
import { createEmptyAvailability } from './createEmptyAvailability'
import { createEmptyEndRules } from './createEmptyEndRules'
import { createEmptyAudience } from './createEmptyAudience'
import { createEmptyInstancePermissions } from './createEmptyInstancePermissions'
import { DEFAULT_DEPLOY_TIME_OF_DAY } from '../constants/availabilityModes'

export const createEmptySchedule = (overrides = {}) => ({
  id: createLocalId('schedule'),
  scheduleId: getRandomScheduleId(),
  version: 1,
  name: '',
  label: '',
  combineAnchors: false,
  resolveTo: RESOLVE_TO.latestOf,
  anchors: [createEmptyAnchor()],
  availability: createEmptyAvailability(),
  repeat: {
    mode: REPEAT_MODE.doesNotRepeat,
    intervalDays: 1,
    intervalWeeks: 1,
    intervalHours: 1,
    intervalMinutes: 30,
    months: 1,
    dayOfMonth: 1,
    daysOfMonth: [1],
    weekdays: ['MO'],
    chapterIntervals: [],
  },
  endRules: createEmptyEndRules(),
  audience: createEmptyAudience(),
  instancePermissions: createEmptyInstancePermissions(),
  targeting: [],
  timeOfDay: DEFAULT_DEPLOY_TIME_OF_DAY,
  ...overrides,
})

/** @deprecated use createEmptySchedule */
export const createEmptyRule = createEmptySchedule
